import * as React from "react";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import { getSiteIconName } from "../../../../utils/CommonUtils";
import { handleUnassignFacility } from "../../../../utils/MenuUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "./FacilityCard.module.css";

const FacilityCard = (props) => {
  const userType = props?.utronUser?.userToUserTypes?.find(
    (userToUserTypes) => userToUserTypes.userType.siteId === props.site.id
  );
  const handleDeleteFacility = () => {
    handleUnassignFacility(props);
  };

  return (
    <div className={classes.facilityContainer}>
      <div className={classes.cardContent}>
        <CustomIcon
          className={classes.siteIcon}
          iconName={getSiteIconName(props.site.clientId)}
        />
        <div className={classes.cardInfo}>
          <span className={classes.siteName}>{props.site.displayName}</span>
          <span className={classes.siteAddress}>{props.site.address}</span>
          <span className={classes.userType}>{userType?.userType?.type}</span>
        </div>
      </div>
      {!props.isViewMode && !props.disableDeletion && (
        <img
          src={Icons.DELETE_ITEM_2}
          className={classes.deleteIcon}
          onClick={handleDeleteFacility}
        />
      )}
      {!props.isViewMode && props.hasCars && (
        <span className={classes.expandButton}>
          {props.expanded ? Strings.USER_INFO.HIDE : Strings.USER_INFO.SHOW}
        </span>
      )}
    </div>
  );
};

export default FacilityCard;
